import { assert } from '@sama/js-core';
import { Point3D } from '../../../team-apis/otterdam/answers/shape-typings';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import { distanceBetween } from '../../utils/point-utils';

export function calculateSubpointHeightDistance(state: PointCloudContentState) {
  const { subpointHeightMeasurement } = state.render;
  assert(
    subpointHeightMeasurement,
    'measurement should be defined when calling this',
  );
  const { reference, target } = subpointHeightMeasurement;
  return Math.abs(reference[2] - target[2]);
}

export function calculateFreePointDistance(
  state: PointCloudContentState,
  groundedImagePoint: Point3D,
) {
  const freePointMeasurement = state.render.freePointMeasurement;
  assert(
    freePointMeasurement,
    'measurement should be defined when calling this',
  );
  return distanceBetween(freePointMeasurement.reference, groundedImagePoint);
}
